/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CashFlowStatementModel { 
    storeIds: Array<number>;
    sumProduct: number;
    sumDelivery: number;
    sumService: number;
    sumProperty: number;
    sumRawMaterials: number;
    sumTaxesProfit: number;
    sumRoyaltyExpenses: number;
    sumOthers: number;
    sumCommercials: number;
    sumAdmins: number;
    sumProductions: number;
    openingBalance: number;
}

